module.exports = __webpack_public_path__ + "img/align_right.2f5b0a12.svg";